// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';
import { OperationType } from 'thehive-sdk';

export const CommentContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();
    const { rootId, action, context } = base;
    const { case: dataCase, alert: dataAlert, message } = data || {};

    const parent = dataAlert || dataCase || context;
    const parentType = parent?._type.toLocaleLowerCase();

    const rootPath =
        parentType === 'alert'
            ? RouteBuilder.compute('alerts.details', { alertId: parent?._id })
            : parentType === 'case'
            ? RouteBuilder.compute('cases.details', { caseId: parent?._id })
            : null;

    const customDetails = {
        message,
    };

    const libTitle: Record<OperationType, string> = {
        create: local('stream.card.comment.create'),
        update: local('stream.card.comment.update'),
        merge: '',
        delete: local('stream.card.comment.delete'),
    };

    return (
        <StreamCard
            icon={<ICONS.CommentOutlined />}
            title={rootPath ? libTitle[action] : libTitle.delete}
            path={rootPath}
            base={base}
            parent={parent}
        >
            {Object.entries(customDetails).map(([key, value]) => (
                <PropRender key={rootId + key} prop={key} value={value} type="comment" />
            ))}
        </StreamCard>
    );
};
